export default __webpack_public_path__ + "static/media/talent.2205c56d.svg";